<i18n src="../../locales/lang.json"></i18n>

<template>
  <div v-bind:id="getId()" style="animation-duration:0.5s" class="text-center animated bounceIn filterbutton-container" v-bind:class="classes">

    <div v-bind:id="'c' + getId()" @click="toggleActive" v-bind:class="getActiveClass(config)" data-popup="tooltip" title="" data-placement="left" data-original-title="" v-bind:style="getActiveStyle(config)" class="filter-title text-center" style="position:absolute;z-index:1;cursor:pointer">
      <span class="filteraction" v-if="config.abbreviation != null" v-bind:data-toggle="getToggle" data-boundary="viewport" v-bind:data-target="'#menu' + getId()" @mouseover="hoverOver" style="font-size: 12px;">{{config.abbreviation}}</span>
      <img class="filteraction" v-if="config.icon != null" data-boundary="viewport" v-bind:src="config.icon" width="50%" v-bind:data-toggle="getToggle" v-bind:data-target="'#menu' + getId()" @mouseover="hoverOver" />
      <i class="filteraction" v-if="config.cssIcon != null" data-boundary="viewport" v-bind:class="config.cssIcon" v-bind:data-toggle="getToggle" v-bind:data-target="'#menu' + getId()" @mouseover="hoverOver" style="margin-top:0px;z-index:1001" />

      <a v-if="readonly == false && config.disabled != true" @click="removeMe" class="filter_remove filter_remove_lnk" style="z-index: 1001;position: absolute; top: -3px; right: -4px;">
        <canvas style="cursor:pointer;position: absolute; top: 0px; right: 0px;" ref="canvas" alt="" v-bind:width="24" v-bind:height="24"></canvas>
      </a>
      <a v-if="readonly == false && config.disabled == true" @click="cantRemove" class="filter_remove filter_remove_lnk" style="z-index: 1001;position: absolute; top: -3px; right: -4px;">
        <canvas style="cursor:pointer;position: absolute; top: 0px; right: 0px;" ref="canvas"  alt="" v-bind:width="24" v-bind:height="24"></canvas>
      </a>
    </div>
    <span v-if="config.menu == null || config.menu.length == 0" class="text-muted mt-1 filter-mobile-small" style="display: block;" v-bind:style="getActiveTextStyle(config)">{{config.text}}</span>

    <span v-if="config.menu != null && config.menu.length > 0" class="text-muted mt-0 filter-mobile-small "  data-toggle="dropdown" style="display: flex;margin-left: -2px;" v-bind:style="getActiveTextStyle(config)"><i class="icon-arrow-down5" style="margin-top:2px;display:inline"></i> {{config.text}}</span>
    <div v-if="config.menu != null && config.menu.length > 0" v-bind:id="'menu' + getId()" class="dropdown dropright" style="position: absolute;line-height: initial;z-index: 10001">
      <div class="skinnedmenu dropdown-menu">
        <a class="dropdown-item" v-bind:class="item.customclass" data-boundary="viewport" v-for="item in config.menu" @click="doCommand(item)">{{item.text}}</a>
      </div>
    </div>
  </div>
</template>

<script>

  var classes = [];
  var showmenu = false;
  

  export default {
    name: "filter-button",
    components: {
      
    },
    props: {
      type: {
        required: false,
        type: String,
        default: ""
      },
      readonly: {
        required: false,
        type: Boolean,
        default: false
      },
      config: {
        required: false,
        type: Object,
        default() {
          return {
            color: "#FFFFFF",
            customstyle: "bg-color:green",
            customclass: "",
            data: 8,
            text: "something",
            icon: null,
            abbreviation: null,
            readonly: false
          }
        },
        menu:[]
      }
    },
    data() {
      return {
        classes,
        showmenu
      };
    },
    
    methods: {
      loadImage(canvas) {

          var ctx = canvas.getContext("2d");

          ctx.clearRect(0, 0, 24, 24);

        ctx.imageSmoothingEnabled = true;
       
          ctx.beginPath();
          ctx.lineWidth = 0;
          ctx.arc(12, 12, 12, 0, 2 * Math.PI, false);
          ctx.fillStyle = this.config.color;
          ctx.fill();

          ctx.beginPath();
          ctx.arc(12, 12, 10, 0, 2 * Math.PI, false);
          ctx.fillStyle = "#FFFFFF";
          ctx.fill();

          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.strokeStyle = this.config.color;
          ctx.moveTo(6, 12)
          ctx.lineTo(17, 12)
          ctx.stroke();

      },
      doCommand(item) {
        if (item.command == "location") {
          this.config.text = item.text;
          this.config.data = item.data;
          vm.$root.$emit('doFilterSearch');
        }
      },
      toggleActive() {
        if (this.type == "siteshift" || this.type == "location") {
          this.config.focused = !this.config.focused;
          this.$emit('focusFilter', this.getId(), this.config.focused, this.config.guid, this.config.parentguid);
        }
      },
      getActiveStyle(config) {
        var style = config.customstyle;
        if (config.focused == true)
          style += "; border:2px #757575 solid;";
        return style;
      },
      getActiveClass(config) {
        var css = config.customclass;
        if (config.mute == true)
          css += " active-button";
        return css;
      },
      getActiveTextStyle(config) {
        var style = "font-size:12px;max-height:20px;overflow:hidden;position:absolute;";
        if (config.focused == true)
          style += "color:black !important;";
        return style;
      },
      addDisplayer(command) {
        
      },
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {
        
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe(e) {
        $('#c' + this.getId()).tooltip('hide');
        this.$emit('remove', this.getId());
        //e.preventdefault();
      },
      cantRemove() {
        alert('This filter is locked for your user account');
      },
      hoverOver: function () {
        
      },
      hoverOut: function () {
        
      },
      hoverOutTimeout: function () {
        
      },
      doUpdateFunction() {
        this.$forceUpdate();
      }
    },
    computed: {
      getToggle: function () {
        if (this.config.menu != null && this.config.menu.length > 0)
          return "dropdown";

        return null;
      },
      getToolTip: function () {
        if (this.config.menu != null && this.config.menu.length > 0)
          if ($('#menu' + this.getId()).hasClass('show'))
            return null;
        return "olle";
      },
      
    },
    mounted() {
      vm.$root.$on('render_filter', this.doUpdateFunction);
      var canvas = this.$refs.canvas;
      if (canvas) {
        this.loadImage(canvas);
      }
      
    },

    created: function () {
      
    },

    watch: {
      
    },
  };

</script>

<style scoped>

  /*
  .active-button:after {
    content: '\A';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255,255,255,.8);
    opacity: 1;
    transition: all 1s;
    -webkit-transition: all 1s;
    border-radius: 50rem !important;
  }*/

  .filteraction{
      cursor:pointer;
  }

  .filterbutton-container {
    margin-left: 15px;
    z-index: auto;
    display: inline-block;
    position: relative;
    width:45px;
    height:45px;
    margin:auto;
    overflow:visible;
    margin-left:10px;
  }

  .filter-badge {
    line-height: 10px;
    font-family: Arial;
    font-size: 12px;
  }

  .filter-badge {
    position: absolute;
    top: -5px;
    right: 0px;
    background-color: #F7F9F9 !important;
    border-color: #9FACAC !important;
    color: #838787 !important;
    cursor: pointer;
    padding-top: 3px;
    padding-bottom: 5px;
    border: 1px solid #838787;
  }

  .filter-title {
    position: absolute;
    width: 45px;
    height: 45px;
    display: block;
    line-height: 38px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    background-color: black;
    color: white;
    text-align: center;
    font-size: 22px;
  }

  .filter-mobile-small {
    max-width: 60px;
    top:45px;
    z-index:100;
    width:100%;
  }

  .filter_remove_lnk {
    top: -2px;
    right: -2px;
    cursor:pointer;
  }
  .filter_remove {
    width: 22px;
    height: 22px;
  }


  @media screen and (max-width:768px) {
    .filter_remove {
      width: 18px;
      height: 18px;
    }
    .filter_remove_lnk {
      top: 0px;
      right: 0px;
    }

    .filterbutton-container {
      margin-left: 5px;
      margin-top:10px;
      height:45px
    }
    .filter-title {
      width: 45px;
      height: 45px;
      line-height: 38px;
      font-size: 10px;
    }
    .font-size-sm{
        font-size:10px;
    }
    .filter-mobile-small {
      max-width: 45px;
      top: 35px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/filter/filter-button.vue